const getFileExtension = (name: string) => name.substring(name.lastIndexOf('.') +1)

export default getFileExtension
